import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const PusherContext = /*#__PURE__*/ createContext(null);
export function PusherProvider(props) {
    const { children, pusher } = props;
    // We intentionally use the initial props.pusher that was provided on mount.
    // Please don't change pusher dynamically.
    const value = useMemo(()=>pusher, []); // eslint-disable-line react-hooks-static-deps/exhaustive-deps
    return /*#__PURE__*/ _jsx(PusherContext.Provider, {
        value: value,
        children: children
    });
}
export const usePusher = ()=>{
    return useContext(PusherContext);
};
